import { motion } from "framer-motion";
import React from "react";
import "./BlurTextAnimation.scss";

interface BlurTextAnimationProps {
  text: string;
  animationState: "active" | "paused" | "inactive";
  style?: React.CSSProperties;
  animateBy?: "word" | "letter";
}

const BlurTextAnimation: React.FC<BlurTextAnimationProps> = ({
  text,
  style,
}) => {
  return (
    <motion.span
      id="blur-text-animation"
      style={{
        display: "inline-block",
        color: "rgba(255,255,255,0.8)",
        position: "relative",
        ...style,
      }}
      animate={{
        opacity: [0.6, 1, 0.6],
      }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    >
      {text}
    </motion.span>
  );
};

export default BlurTextAnimation;
